<template>
  <div>
    <MobCollapse header="Explicación">
      <p>
        El opuesto de un número está a la misma distancia de 0 en el otro lado
        de la recta numérica. El número −3, está 3 unidades a la izquierda de 0
        en la recta numérica.
      </p>
    </MobCollapse>
  </div>
</template>

<script>
import { MobCollapse } from "@/views/V2/components";

export default {
  name: "LessonExplanation",
  components: {
    MobCollapse,
  },
};
</script>
